module.exports = __webpack_public_path__ + "img/portfolio-full-width-light.b94ab00a.png";